"use strict";

var _defineProperty2 = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Core = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Core = function Core(id, events, subject) {
  var _this = this;

  _classCallCheck(this, Core);

  _defineProperty(this, "rpcId", void 0);

  _defineProperty(this, "subjectId", void 0);

  _defineProperty(this, "pipe", void 0);

  _defineProperty(this, "rpc", void 0);

  _defineProperty(this, "events", void 0);

  this.rpcId = "_FURE_CORE_RPC-".concat(id);
  this.subjectId = "_FURE_CORE_SUBJECT-".concat(id);
  this.pipe = subject.pipe.bind(subject); //#region BACKEND

  if (typeof window === 'undefined') {
    this.rpc = function (event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return Promise.resolve(events[event].apply(events, args));
    };

    this.events = Object.keys(events).reduce(function (dict, key) {
      return _objectSpread({}, dict, _defineProperty2({}, key, _this.rpc.bind(null, key)));
    }, {}); // expose `subject` for the main process of `carlo` to listen from.

    this[this.subjectId] = subject; // eslint-disable-line @typescript-eslint/no-explicit-any

    return;
  } //#endregion
  //#region FRONTEND
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var g = window; // eslint-disable-line no-undef

  if (g[this.rpcId] instanceof Function) {
    this.rpc = g[this.rpcId];
    this.events = Object.keys(events).reduce(function (dict, key) {
      return _objectSpread({}, dict, _defineProperty2({}, key, _this.rpc.bind(null, key)));
    }, {}); // expose `subject` for the view process of `carlo` to send forward.

    g[this.subjectId] = subject;
    return;
  } //#endregion
  //#region FRONT-ONLY MOCK


  this.rpc = function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return Promise.resolve(events[event].apply(events, args));
  };

  this.events = Object.keys(events).reduce(function (dict, key) {
    return _objectSpread({}, dict, _defineProperty2({}, key, function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      // delay 1ms to emulate the frontend-backend RPC call delay.
      return (0, _rxjs.interval)(1).pipe((0, _operators.take)(1)).toPromise().then(function () {
        return _this.rpc.apply(_this, [key].concat(args));
      });
    }));
  }, {}); //#endregion
};

exports.Core = Core;

_defineProperty(Core, "main", function () {
  var main = require('./main').default;

  if (typeof window !== 'undefined') return main;
  return require('./main/main').default;
}());